'use client';

import {
  Navbar,
  NavbarBrand,
  NavbarContent,
  NavbarItem,
  NavbarMenu,
  NavbarMenuItem,
  NavbarMenuToggle,
} from '@nextui-org/react';
import { useSession } from 'next-auth/react';
import Link from 'next/link';
import { usePathname, useRouter } from 'next/navigation';

import { ButtonSubmit, Logo } from '@/components';
import { ROUTES } from '@/constaint/route';
import useAuthRecruiter from '@/hooks/useAuthRecruiter';
import { useCallback, useEffect, useState } from 'react';
import MenuContact from './MenuContact';
import MenuNotification from './MenuNotification';
import MenuUserRecruiter from './MenuUserRecruiter';

const MENU_CONFIG = [
  {
    title: 'Home',
    url: ROUTES.HOME,
    isPrivate: false,
  },
  {
    title: 'Jobs',
    url: ROUTES.RECRUITER.JOB_LIST,
    isPrivate: false,
  },
];

const NavbarRecruiter = () => {
  const router = useRouter();
  const { status, data: session } = useSession();
  const { openAuthRecruiter } = useAuthRecruiter();
  const [isAtTop, setIsAtTop] = useState(true);
  const pathname = usePathname();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsAtTop(false);
      } else {
        setIsAtTop(true);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleNavigate = async (url: string, isPrivate: boolean) => {
    if (isPrivate && status === 'unauthenticated') {
      return openAuthRecruiter();
    }

    setIsMenuOpen(false);
    return router.push(url);
  };

  const isActive = useCallback(
    (url: string) => {
      if (url === ROUTES.RECRUITER.JOB_LIST) {
        return pathname.startsWith(ROUTES.RECRUITER.JOB_LIST);
      }

      return pathname === url;
    },
    [pathname],
  );

  console.log(session);

  return (
    <Navbar
      maxWidth='xl'
      isMenuOpen={isMenuOpen}
      onMenuOpenChange={setIsMenuOpen}
      classNames={{
        base: `${!isAtTop ? 'shadow-lg' : ''} flex w-full h-20 mx-auto justify-center z-50`,
        wrapper: 'px-4',
      }}
    >
      <NavbarBrand>
        <Link href='/' className='flex items-center gap-2'>
          <Logo />
          <b className='text-lg font-bold'>KitesHR</b>
        </Link>
      </NavbarBrand>
      <NavbarContent justify='center' className='hidden md:flex gap-8'>
        {MENU_CONFIG.map(({ title, url, isPrivate }, index: number) => (
          <NavbarItem key={index}>
            <div
              className={`cursor-pointer font-semibold text-base ${isActive(url) ? 'text-secondary' : 'text-gray-500 hover:opacity-50'}`}
              onClick={() => handleNavigate(url, isPrivate)}
            >
              {title}
            </div>
          </NavbarItem>
        ))}
        <NavbarMenuToggle className='md:hidden' />
        <NavbarItem>
          <MenuContact />
        </NavbarItem>
      </NavbarContent>
      <NavbarContent justify='end'>
        <NavbarMenuToggle className='md:hidden' />
        {status === 'authenticated' && (
          <>
            {session?.user?.isActive && (
              <>
                <NavbarItem>
                  <MenuNotification />
                </NavbarItem>
                <NavbarItem>
                  <MenuUserRecruiter />
                </NavbarItem>
              </>
            )}
            {!session?.user?.isActive && (
              <NavbarItem>
                <ButtonSubmit onClick={openAuthRecruiter}>Sign In</ButtonSubmit>
              </NavbarItem>
            )}
          </>
        )}
        {status === 'unauthenticated' && (
          <NavbarItem>
            <ButtonSubmit onClick={openAuthRecruiter}>Sign In</ButtonSubmit>
          </NavbarItem>
        )}
      </NavbarContent>
      <NavbarMenu className='container'>
        {MENU_CONFIG.map(({ title, url, isPrivate }, index: number) => (
          <NavbarMenuItem key={index} className='text-center py-3'>
            <div
              onClick={() => handleNavigate(url, isPrivate)}
              className={`cursor-pointer font-semibold ${
                isActive(url) ? 'text-secondary' : 'text-gray-500 hover:opacity-50'
              }`}
            >
              {title}
            </div>
          </NavbarMenuItem>
        ))}
        <NavbarMenuItem className='flex justify-center py-3'>
          <NavbarItem>
            <MenuContact />
          </NavbarItem>
        </NavbarMenuItem>
        {session?.user?.isActive && (
          <NavbarMenuItem className='flex justify-center py-3'>
            <NavbarItem>
              <MenuNotification />
            </NavbarItem>
          </NavbarMenuItem>
        )}
      </NavbarMenu>
    </Navbar>
  );
};

export default NavbarRecruiter;
